import { configureStore } from "@reduxjs/toolkit";
import LayoutReducer from "./Reducers/Layout/LayoutReducer";
import ThemeCustomizerReducer from "./Reducers/Layout/ThemeCustomizerReducer";
import BookmarkReducer from "./Reducers/BookmarkReducer";
import FormStatusSlice from "./Reducers/FromStatusSlice";
import formDataSlice from "./Reducers/FormDataSlice";
import authSlice from "./Reducers/AuthSlice";
import profileSlice from "./Reducers/ProfileSlice";
import homeLoanSlice from "./Reducers/HomeLoanSlice";
import homeResultsSlice from "./Reducers/HomeResultsSlice";
import AdminAuthSlice from "./Reducers/AdminAuthSlice";
import RoleSlice from "./Reducers/RoleSlice";
import assetsSlice from "./Reducers/AssetsSlice";
import dashboardSlice from "./Reducers/DashboardSlice";
import factFindDataSlice from "./Reducers/FactFindDataSlice";

export const store = configureStore({
  reducer: {
    layout: LayoutReducer,
    themeCustomizer: ThemeCustomizerReducer,
    bookmark: BookmarkReducer,
    formStatus: FormStatusSlice,
    formData : formDataSlice,
    auth : authSlice,
    profile : profileSlice,
    homeLoan : homeLoanSlice,
    homeLoanResults : homeResultsSlice,
    adminAuth : AdminAuthSlice,
    roles : RoleSlice,
    assets : assetsSlice,
    dashboard : dashboardSlice,
    factFind : factFindDataSlice
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
